import campaignService from '@/services/campaign'

export const insertConsumerB2C = async ({ commit }, data) => {
    return await campaignService.insertConsumerB2C(data)
}

export const pesqCep = async ({ commit }, cep) => {
    return await campaignService.pesqCep(cep)
}